/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */

import React, { PropsWithChildren } from "react";
import styles from "./badge.module.sass";
import cn from "classnames";

export enum TypeBadge {
	success,
	error,
	warn,
	info,
}

export interface IBadge extends PropsWithChildren {
	type?: keyof typeof TypeBadge;
	color?: string;
}

/**
 * @param {IBadge} props
 * @param {any} props.children - потомки для оборачивания
 * @param {("error"|"success"|"info"|"warn")} [props.type] - принимает одно из четырех значений для отображения необходимого цвета
 * @constructor
 */
const Badge: React.FC<IBadge> = ({ children, color, type = "success" }) => {
	return (
		<div
			className={cn(styles.badge, !color && styles[`badge__${type}`])}
			style={{
				...(color && {
					borderColor: color,
					color: color,
				}),
			}}>
			{color && (
				<div
					className={styles.bg}
					style={{
						...(color && {
							backgroundColor: color,
							filter: "opacity(10%)",
						}),
					}}
				/>
			)}
			<div className={color ? styles.badge_text_inherit : styles.badge_text}>{children}</div>
		</div>
	);
};

export default Badge;
